import { toast } from "react-toastify";
import * as actionType from "../../../context/actions";

/**
 * Edit or add customer locally if name matches. Similar to Firebase structure.
 */
const EditCustomerDataInLocal = async (state, dispatch, customerData) => {


    try {
        const existingCustomers = state?.CUSTOMERS || [];

        let matchedCustomer = null;
        let existingCustomerIndex = -1;

        // 🔍 Find by name match (case-insensitive)
        existingCustomers.forEach((customer, index) => {
            if (
                customer.customer?.toLowerCase() === customerData.customer?.toLowerCase()
            ) {
                matchedCustomer = customer;
                existingCustomerIndex = index;
            }
        });

        if (!matchedCustomer) {
            // ➕ Create new customer if not found
            const newCustomer = {
                ...customerData,
                customerId: Date.now().toString(),
                createdAt: Date.now().toString(),
                updatedAt: Date.now().toString(),
                invoiceCount: 1,
                //invoices: [customerData.invoices?.[0] || ""],
                totalPaid: 0,
                dialCode: customerData?.dialCode || customerData?.dial_code || "",

            };

            const updatedCustomers = [...existingCustomers, newCustomer];

            dispatch({
                type: actionType.CUSTOMERS,
                payload: updatedCustomers,
            });
        } else {
            // ✏️ Update existing customer fields
            const updatedCustomer = {
                ...matchedCustomer,
                phone: customerData.phone,
                email: customerData.email,
                address: customerData.address,
                customerGSTNo: customerData.customerGSTNo,
                updatedAt: Date.now().toString(),
                dialCode: customerData?.dialCode || customerData?.dial_code || "",
                currency: customerData.currency || matchedCustomer?.currency || "",
                // country: customerData.country || matchedCustomer?.country || "",
                // countryCode: customerData.countryCode || matchedCustomer?.countryCode || "",
            };

            const updatedCustomers = existingCustomers.map((cust, i) =>
                i === existingCustomerIndex ? updatedCustomer : cust
            );

            dispatch({
                type: actionType.CUSTOMERS,
                payload: updatedCustomers,
            });
        }
    } catch (error) {
        console.error("❌ EditCustomerDataInLocal error:", error);
    }
};

export default EditCustomerDataInLocal;
